import { render } from "./app-loading.vue?vue&type=template&id=6165175e"
import script from "./app-loading.vue?vue&type=script&lang=js"
export * from "./app-loading.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/loading/app-loading.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6165175e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6165175e', __exports__)) {
    console.log('reload')
    api.reload('6165175e', __exports__)
  }
  
  module.hot.accept("./app-loading.vue?vue&type=template&id=6165175e", () => {
    console.log('re-render')
    api.rerender('6165175e', render)
  })

}


export default __exports__